import { Component, OnInit } from '@angular/core';
import { AdminService, TierConfig } from '../../core/services/admin.service';

interface TierRow extends TierConfig {
  editing: boolean;
  draftLimit: number;
  draftTeamLimit: number;
  draftCost: number;
  saving: boolean;
  saveSuccess: boolean;
  saveError: string;
}

@Component({
  selector: 'app-tier-management',
  templateUrl: './tier-management.component.html',
})
export class TierManagementComponent implements OnInit {
  tiers: TierRow[] = [];
  loading = true;
  error = '';

  constructor(private readonly adminService: AdminService) {}

  ngOnInit(): void {
    this.adminService.getTierConfigs().subscribe({
      next: res => {
        this.tiers = res.tiers.map(t => ({
          ...t,
          editing: false,
          draftLimit: t.maxMonitoredServices,
          draftTeamLimit: t.maxTeamMembers,
          draftCost: t.monthlyCost,
          saving: false,
          saveSuccess: false,
          saveError: '',
        }));
        this.loading = false;
      },
      error: () => {
        this.error   = 'Failed to load tier configuration.';
        this.loading = false;
      },
    });
  }

  startEdit(row: TierRow): void {
    row.draftLimit      = row.maxMonitoredServices;
    row.draftTeamLimit  = row.maxTeamMembers;
    row.draftCost       = row.monthlyCost;
    row.editing         = true;
  }

  cancelEdit(row: TierRow): void {
    row.draftLimit      = row.maxMonitoredServices;
    row.draftTeamLimit  = row.maxTeamMembers;
    row.draftCost       = row.monthlyCost;
    row.editing         = false;
  }

  save(row: TierRow): void {
    if (row.draftLimit < 1 || !Number.isInteger(row.draftLimit)) return;
    if (row.draftTeamLimit < 1 || !Number.isInteger(row.draftTeamLimit)) return;
    if (row.draftCost < 0 || !Number.isFinite(row.draftCost)) return;
    row.saving      = true;
    row.saveError   = '';
    row.saveSuccess = false;
    this.adminService.updateTierConfig(row.tier, row.draftLimit, row.draftTeamLimit, row.draftCost).subscribe({
      next: updated => {
        row.maxMonitoredServices = updated.maxMonitoredServices;
        row.maxTeamMembers       = updated.maxTeamMembers;
        row.monthlyCost          = updated.monthlyCost;
        row.updatedAt            = updated.updatedAt;
        row.editing              = false;
        row.saving               = false;
        row.saveSuccess          = true;
        setTimeout(() => { row.saveSuccess = false; }, 3000);
      },
      error: () => {
        row.saving    = false;
        row.saveError = 'Save failed. Please try again.';
      },
    });
  }

  tierBadgeClass(tier: string): string {
    const map: Record<string, string> = {
      FREE:       'bg-zinc-100 text-zinc-700',
      PRO:        'bg-blue-100 text-blue-700',
      ENTERPRISE: 'bg-violet-100 text-violet-700',
      CUSTOM:     'bg-amber-100 text-amber-700',
    };
    return map[tier] ?? 'bg-zinc-100 text-zinc-600';
  }
}
